import React from 'react';
import styles from './ConteudoImagem.module.css';
import VisualizadorImagem from '../../../components/layout/VisualizadorImagem';

export const ConteudoImagem = ({ value }: { value: string }) => {
    const [showImg, setShowImg] = React.useState<boolean>(false);

    const path = value.split('/');
    const filename = path[path.length - 1];
    const dir = path.slice(0, path.length - 1).join('/');

    const result = [dir, encodeURIComponent(filename)].join('/');

    return (
        <>
            <VisualizadorImagem
                show={showImg}
                src={`/api/assets${result}`}
                nomeArquivo={filename}
                onClose={() => setShowImg(false)}
            />

            <div className={styles.container} onClick={() => setShowImg(true)}>
                <img className={[styles.img, 'rr-block'].join(' ')} src={`/api/assets${result}`} alt="imagem" />
            </div>
        </>
    )
}